import { useEffect, useState } from "react";
import "./PolicySyncing.css"
import SPIMG from "../../../Images/customer/SyncPolicy.svg";
import PolicySyncingForm from "./PolicySyncingForm";

const PolicySyncing = () => {
    const [PolicySincForm, setPolicySincForm] = useState(false);
    const [PolicySincCNT, setPolicySincCNT] = useState(true);

    const IsOpenPSF = () => {
        setPolicySincForm(true)
        setPolicySincCNT(false)
    }


    return (
        <>
            <h4>Sync your policy with SMC</h4>
            {PolicySincCNT &&
                <div className="SyncPolicyMain">
                    <PolicySyncingForm />

                    <div className="SyncPolicy">
                        <h5>The benefits of syncing your policy with us</h5>
                        <ul>
                            <li>Prompt policy renewal reminders to ensure you don't miss the due date.</li>
                            <li>Claim assistance from SMC without any added cost.</li>
                            <li>Coalition of all insurance policies at a single place.</li>
                            <li>Easy accessibility of renewal dates on Premium Calendar feature.</li>
                        </ul>
                    </div>
                </div>
            }
            {PolicySincForm &&
                <PolicySyncingForm />
            }
        </>
    );
};

export default PolicySyncing;
